import {
    Checkbox,
    Dropdown,
    Icon,
    PrimaryButton,
    Stack,
    TextField,
    Calendar,
    defaultCalendarStrings,
} from "@fluentui/react";
import React, { useContext, useEffect, useRef, useState } from "react";
import Moment from "moment";

import "./AuditLogFilter.css";
import { useTranslation } from "react-i18next";

const initialState = {
    dateFrom: new Date(),
    dateTo: new Date(),
};
  
const AuditLogFilter = (props) => {
    const ref = useRef(null);
    const { onClickOutside } = props;

    const [t] = useTranslation();

    const dropDownStyle = {
        dropdown: {
          width: "100%",
        },
        dropdownItemSelected: {
          fontSize: "12px",
          lineHeight: "18px",
          fontWeight: "600",
        },
        dropdownItemsWrapper: {
          maxHeight: "300px"
        },
        dropdownItem: {
          fontSize: "12px",
          lineHeight: "18px",
          fontWeight: "600",
          color:"white"
        },
    };

    const formatDate = (date) => {
        var currentDate = Moment(date).local().format("YYYY-MM-DD");
        return date == "" ? "" : currentDate;
    };
  
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (ref.current && !ref.current.contains(event.target)) {
          onClickOutside && onClickOutside();
        }
      };
      document.addEventListener("click", handleClickOutside, true);
      return () => {
        document.removeEventListener("click", handleClickOutside, true);
      };
    }, [onClickOutside]);
  
    if (!props.show) return null;
  
    const calendarStyle = {
      root: {
        color: "#A19F9D",
        background: "transparent"
      },
      goTodayButton: {
        color: "#A19F9D",
      },
      headerIconButton: {
        color: "#A19F9D",
      },
      daySelected: {
        background: "#5A5A5A",
      },
      dayIsToday: {
        background: "red",
      },
      liveRegion: {
        color: "#A19F9D",
      },
      weekDayLabelCell: {
        paddingLeft: "2px",
      },
    };
  
    const checkboxStyle = {
      root: {
        margin: "10px 0",
      },
      text: {
        color: "#A19F9D",
        fontWeight: "400",
        fontSize: "14px",
      },
      checkbox: {
        borderColor: "#A19F9D",
      },
    };

    let userActionList = [];
    let index = 0;

    // console.log("userAction menu list---->",props.userActionMenuList);
    props.userActionMenuList?.map((userAction) => {
        userActionList.push({
        key: index+1,
        text: userAction,
        });
        index++;
    });

    const dateFromFunction = (event) => {
      console.log("date from in filter------>",event);
        props.setAuditFilterObj({ ...props.auditFilterObj, startDateObj: event });
    };

    const dateToFunction = (event) => {
      console.log("date to in filter------>",event);
        props.setAuditFilterObj({ ...props.auditFilterObj, endDateObj: event });
    };

    const userActionFunction = (event, selected) => {
      console.log("useraction in filter------>",event,selected);
        props.setAuditFilterObj({ ...props.auditFilterObj, userActionDropdownObj: selected.text });
    };
    const entityIdFunction = (event) => {
      console.log("entity id in filter------>",event.target.value);
        props.setAuditFilterObj({ ...props.auditFilterObj, entityIdObj: event.target.value });
    };
    const usernameFunction = (event) => {
      console.log("username in filter------>",event);
        props.setAuditFilterObj({ ...props.auditFilterObj, userNameObj: event.target.value });
    };
  
    return (
      <>
        <div className="filter-popup-auditlogs" ref={ref}>
          {
            <>
              <div className="user-action-section align-filter-section">
                <div
                  className="modal-scroll"
                  style={{ height: "380px", overflowY: "auto" }}
                >
                    <Dropdown
                        styles={dropDownStyle}
                        placeholder={t("placeholder.select-user-action")}
                        // defaultSelectedKey={userActionList[0].text}
                        label="User Actions"
                        options={userActionList}
                        onChange={userActionFunction}
                    />
                    <TextField
                        className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                        label="Entity Id"
                        name="entityId"
                        placeholder={t("placeholder.search")}
                        value={props.auditFilterObj.entityIdObj}
                        // onBlur={props.handleBlur}
                        onChange={entityIdFunction}
                        styles={{backgroundColor: "#2e3033"}}
                    />
                    <TextField
                        className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                        label="Username"
                        name="username"
                        placeholder={t("placeholder.search")}
                        value={props.auditFilterObj.userNameObj}
                        // onBlur={props.handleBlur}
                        onChange={usernameFunction}
                        styles={{backgroundColor: "#2e3033"}}
                    />
                </div>
              </div>
            </>
          }
          <div className="filter-section-seperator"></div>
          {
            <>
            <div className="date-filter-section align-filter-section">
                <span className="filter-section-text">{t("audit-logs.audit-from")}</span>
                <div
                  className="modal-scroll"
                  style={{ height: "280px", overflowY: "auto" }}
                >
                  <ul className="date-from-ul">
                    <Calendar
                      showMonthPickerAsOverlay={true}
                      placeholder={t("placeholder.select-date")}
                      ariaLabel="Select a date"
                      // DatePicker uses English strings by default. For localized apps, you must override this prop.
                      styles={calendarStyle}
                      showGoToToday={false}
                      strings={defaultCalendarStrings}
                      onSelectDate={dateFromFunction}
                      // value={props.auditFilterObj.endDateObj}
                    />
                  </ul>
                </div>
              </div>
            </>
          }
          <div className="filter-section-seperator"></div>
          {
            <>
            <div className="date-filter-section align-filter-section">
                <span className="filter-section-text">{t("audit-logs.audit-to")}</span>
                <div
                  className="modal-scroll"
                  style={{ height: "280px", overflowY: "auto" }}
                >
                  <ul className="date-from-ul">
                    <Calendar
                      showMonthPickerAsOverlay={true}
                      placeholder={t("placeholder.select-date")}
                      ariaLabel="Select a date"
                      // DatePicker uses English strings by default. For localized apps, you must override this prop.
                      styles={calendarStyle}
                      showGoToToday={false}
                      strings={defaultCalendarStrings}
                      onSelectDate={dateToFunction}
                      // value={props.auditFilterObj.endDateObj}
                    />
                  </ul>
                </div>
              </div>
            </>
          }
        </div>
      </>
    );
  };
  
  export default AuditLogFilter;